import React, { FC, useEffect } from 'react';
import { styled } from 'linaria/react';
import { Text, TextButton } from '@shared/ui/atoms';
import { getTotalDuration } from '../lib/getTotalDuration';
import { useTimer } from '../lib/useTimer';
interface TimerProps {
  duration?: number;
  onSendCodeClick?: () => void;
  isTimerActive?: boolean;
}
const Timer: FC<TimerProps> = ({
  duration,
  onSendCodeClick,
  isTimerActive
}) => {
  const {
    seconds,
    isActive,
    start,
    reset
  } = useTimer({
    initialDuration: duration
  });
  useEffect(() => {
    if (isTimerActive) start(duration);else reset(duration);
  }, [isTimerActive]);
  const handleResendCodeClick = () => {
    start(duration);
    return onSendCodeClick?.();
  };
  return <TimerWrapper>
      {isActive ? <Text family="MTSCompact" size={{
      desktop: 'pM',
      mobile: 'pS'
    }} weight="medium" color="secondary">
          Получить новый код можно через <SecondsWrapper>{getTotalDuration(seconds)}</SecondsWrapper>
        </Text> : <TextButton onClick={handleResendCodeClick}>
          <Text family="MTSCompact" size="pM" weight="medium">
            Выслать код повторно
          </Text>
        </TextButton>}
    </TimerWrapper>;
};
export default Timer;
const TimerWrapper = /*#__PURE__*/styled('div')({
  name: "TimerWrapper",
  class: "t1ah7j8d",
  propsAsIs: false
});
const SecondsWrapper = /*#__PURE__*/styled('span')({
  name: "SecondsWrapper",
  class: "s4311jm",
  propsAsIs: false
});

require("./Timer.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Timer.tsx");